import { mapGetters, mapMutations } from 'vuex';
import applCode from '@/const/applCodeConstants';
import dayjs from 'dayjs';

export default {
  data: () => ({}),
  computed: {
    ...mapGetters('ELA', ['GET_APP_MENU', 'GET_GNT_CD']),
    // 연장근무
    isOtWork() {
      return this.GET_APP_MENU.applCd === applCode.OtWork;
    },
    // 출퇴근 변경
    isAttend() {
      return this.GET_APP_MENU.applCd === applCode.Attend;
    },
    // 근무스케쥴 변경
    isSchedule() {
      return this.GET_APP_MENU.applCd === applCode.Schedule;
    },
    // 보상휴가
    isReward() {
      return this.GET_APP_MENU.applCd === applCode.Reward;
    },
    // 근태
    isVacation() {
      return this.GET_APP_MENU.applCd === applCode.Vacation;
    },
    // 출장신청
    isBizTrip() {
      return this.GET_APP_MENU.applCd === applCode.BizTrip;
    },
    // 취소신청 - 근태
    isCancelVacation() {
      return this.GET_APP_MENU.applCd === applCode.CancelVacation;
    },
    // 취소신청 - 보상
    isCancelReward() {
      return this.GET_APP_MENU.applCd === applCode.CancelReward;
    },
    // 근태 - 대체휴가
    isAlterVacation() {
      return (
        (this.isVacation || this.isCancelVacation) &&
        this.GET_GNT_GUBUN_CD === '11'
      );
    },
    // 선택근무신청
    isSelectWork() {
      return this.GET_APP_MENU.applCd === applCode.SelectWork;
    },
    // 경조금신청
    isOcc() {
      return this.GET_APP_MENU.applCd === applCode.Occ;
    },
    // 경조휴가신청
    isOccVac() {
      return this.GET_APP_MENU.applCd === applCode.OccVac;
    },
    // 잔여 연차 노출 여부
    showRestCnt() {
      return this.isVacation && this.GET_GNT_CD.gntCdDel !== null;
    },
    todayYM() {
      return dayjs().format('YYYYMM');
    },
    todayYMD() {
      return dayjs().format('YYYYMMDD');
    },
    todayYMDHypen() {
      return dayjs().format('YYYY-MM-DD');
    },
  },
  methods: {
    ...mapMutations('SPINNER', ['ON_APP_SPINNER', 'OFF_APP_SPINNER']),
  },
  destroyed() {
    this.OFF_APP_SPINNER();
  },
};
